import React, { useEffect, createRef } from 'react';
import ContentCard from '../../../common/ContentCard';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import BarChart from '../../../charts/BarChart';
import { getActivityData, getActivityLoading } from '../selectors';
import { activityRequested } from '../actions';
import { DROPDOWNDATA as YEARS } from './constants';
import { DROPDOWN_VARIANTS } from '../../../common/constants';
import LoadingComponent from '../../../common/LoadingComponent';
import downloadAsImage from '../../../helpers/downloadAsImage';
import './styles.scss';

function ActivityCalendar({ data, onLoad, activityLoading }) {
    useEffect(() => {
        onLoad(YEARS[0].key);
    }, []);

    const ref = createRef();

    const loader = (
        <div className="activityLoader">
            <LoadingComponent isLoading={activityLoading} />
        </div>
    );

    const mainContent = activityLoading ? (
        loader
    ) : (
        <div className="card-body p-lg-4 p-0">
            <BarChart
                width={800}
                height={600}
                radius={30}
                data={data}
                xLabel={'month'}
                yLabel={'count'}
            />
        </div>
    );

    return (
        <ContentCard
            heading={'Activity Calendar'}
            subHeading={
                'How your total challenges have performed month by month.'
            }
            showDropDown={true}
            dropDownData={YEARS}
            dropDownLabel={'Select Year'}
            dropDownOnClick={onLoad}
            dropDownVariant={DROPDOWN_VARIANTS.LIST_SIMPLE}
            content={mainContent}
            id="activityCalendar"
            downloadable={true}
            onDownloadClick={(filetype) => {
                if (ref) {
                    downloadAsImage(ref.current, 'activityCalendar', filetype);
                }
            }}
            ref={ref}
        />
    );
}

ActivityCalendar.propTypes = {
    // data to populate in bar chart
    data: PropTypes.arrayOf(PropTypes.object).isRequired,
    // activity data to fetch onLoad and onSelect
    onLoad: PropTypes.func.isRequired,
    // boolean state to determine whether to show the loading state
    activityLoading: PropTypes.bool,
};

const mapStateToProps = (state) => {
    return {
        data: getActivityData(state),
        activityLoading: getActivityLoading(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onLoad: (year) => dispatch(activityRequested(year)),
    };
};

const ConnectedActivityCalendar = connect(
    mapStateToProps,
    mapDispatchToProps,
)(ActivityCalendar);

export default ConnectedActivityCalendar;
